import React from "react";
import { Send, Search, PlayCircle, Wrench } from "lucide-react";

const steps = [
  {
    icon: Send,
    title: "U vult het formulier in",
    text: "Laat uw gegevens, website en sector achter.",
  },
  {
    icon: Search,
    title: "Wij bekijken uw situatie",
    text:
      "We bekijken uw website, type bedrijf en waar bezoekers mogelijk afhaken.",
  },
  {
    icon: PlayCircle,
    title: "U krijgt een duidelijke demo",
    text:
      "We tonen hoe een AI-chatbot bezoekers kan helpen, vragen kan beantwoorden en aanvragen kan verzamelen.",
  },
  {
    icon: Wrench,
    title: "Bij interesse bouwen we verder",
    text:
      "Als het relevant voelt, bouwen, trainen en installeren we de chatbot op maat op uw website.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="hoe-werkt-het" className="relative py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            Het proces
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            Wat gebeurt er na uw{" "}
            <span className="text-gradient-neon">demo-aanvraag?</span>
          </h2>
          <p className="mt-4 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            Geen verplichting, geen ingewikkeld proces. We bekijken eerst of een
            AI-chatbot nuttig kan zijn voor uw bedrijf.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 relative">
          <div
            className="hidden lg:block absolute left-[10%] right-[10%] top-[44px] h-px pointer-events-none"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(168,255,0,0.4), rgba(0,239,255,0.4), transparent)",
            }}
          />
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`step-card-${i + 1}`}
                className="relative glass rounded-2xl p-5 md:p-6 hover:border-[#00EFFF]/25 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div className="relative">
                    <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-neon glow-soft">
                      <Icon className="h-5 w-5 text-[#0A0A1A]" strokeWidth={2.5} />
                    </div>
                    <span className="absolute -top-2 -right-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#0A0A1A] border border-white/15 font-mono-display text-[10px] text-white">
                      {i + 1}
                    </span>
                  </div>
                  <div className="font-mono-display text-[10px] tracking-[0.22em] text-[#A7A7A7]">
                    STAP&nbsp;<span className="text-gradient-neon">0{i + 1}</span>
                  </div>
                </div>
                <h3 className="mt-4 font-display font-semibold text-white text-base md:text-lg leading-snug">
                  {s.title}
                </h3>
                <p className="mt-1.5 text-[#A7A7A7] text-sm leading-relaxed">
                  {s.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
